import { CheckItem, Container, IconTile, LandingButton, SectionHeading, SIGN_UP_PATH } from "./primitives";

const WAYS = [
  {
    icon: "lucide:cloud-upload",
    chip: "Upload",
    title: "Upload once, we handle the rest",
    body: "Drag in ZIP files, PDFs, scans, or exports from any EHR. We auto-detect the format, extract the clinical data, and organize it into your dashboard, regardless of which hospital system it came from.",
    points: ["Any format accepted", "OCR for scanned documents", "Batch upload supported"],
    cta: "Start Uploading",
  },
  {
    icon: "lucide:refresh-cw",
    chip: "Connect",
    title: "Connect anytime, get your latest records",
    body: "Sign in with your hospital's patient portal and MedSyncIQ pulls in your lab results, visit notes, and imaging reports. Want the newest updates? Just reconnect and we'll fetch your latest records.",
    points: ["Works with hundreds of Epic hospitals", "Your portal password never reaches us", "Refresh anytime with one quick sign-in"],
    cta: "Connect Your Portal",
  },
];

export function GettingStartedSection() {
  return (
    <section id="getting-started" className="scroll-mt-[68px] bg-[#F8F9FB] pt-[88px] pb-20 lg:pt-[108px] lg:pb-[100px]">
      <Container>
        <SectionHeading
          eyebrow="Getting started"
          title="Two ways to bring in your records"
          subtitle="Both work the same way once inside. Choose what fits your situation."
        />

        <div className="mt-14 grid gap-7 md:grid-cols-2 lg:mt-16">
          {WAYS.map(way => (
            <article key={way.chip} className="flex flex-col rounded-[20px] border border-[#E8E9EE] bg-white p-7 lg:p-9">
              <div className="flex items-center gap-3.5">
                <IconTile
                  icon={way.icon}
                  className="h-12 w-12 rounded-xl bg-[#FDEBEE]"
                  iconClassName="h-[22px] w-[22px] text-[#F18095]"
                />
                <span className="flex h-[26px] items-center rounded-md bg-[#F3F4F8] px-3 text-[12px] font-bold uppercase tracking-[0.06em] text-[#6B7280]">
                  {way.chip}
                </span>
              </div>
              <h3 className="!mt-[26px] text-[22px] font-extrabold leading-7 tracking-[-0.025em] text-[#120240]">
                {way.title}
              </h3>
              <p className="!mt-3 text-[15.5px] leading-[26px] text-[#4B5563]">{way.body}</p>
              <ul className="!mt-5 space-y-2.5 text-[15px] text-[#374151]">
                {way.points.map(p => <CheckItem key={p} tone="green">{p}</CheckItem>)}
              </ul>
              <div className="mt-auto pt-8">
                <LandingButton variant="outline" arrow to={SIGN_UP_PATH} className="!h-[46px] !px-6 !text-[15px]">
                  {way.cta}
                </LandingButton>
              </div>
            </article>
          ))}
        </div>
      </Container>
    </section>
  );
}
